import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, inject, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDateRangePicker } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { AppService } from 'src/app/app.service';
import { AccountBilling } from 'src/app/gdo/gdo-shared/Models/account-billing';
import { Transaction_Types, transformIntoApiCallObj } from 'src/app/gdo/gdo-shared/Models/Constants';
import { AppliedFilters } from 'src/app/gdo/gdo-shared/Models/Models';
import { GdoPaymentService } from '../../gdo-payment.service';
import { GdoAdvancedFilterationOptionsComponent } from './gdo-advanced-filteration-options/gdo-advanced-filteration-options.component';
import { GdoViewInvoiceComponent } from './gdo-view-invoice/gdo-view-invoice.component';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-gdo-account-billing-history',
  templateUrl: './gdo-account-billing-history.component.html',
  styleUrls: ['./gdo-account-billing-history.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class GdoAccountBillingHistoryComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);

  student: AccountBilling[] = [];
  // columns we will show on the table
  // public displayedColumns = [
  //   'date',
  //   'type',
  //   'desc',
  //   'amount',
  //   'action',
  // ];

  filterForm!: UntypedFormGroup;
  filterTypes = [{ value: 'Last 6 Months' }, { value: 'Last Year' }, { value: 'Custom Range' }];



  @ViewChild('picker')
  datePicker!: MatDateRangePicker<Date>;
  dateFilter: string = "dateFilter";

  displayedColumns: string[] = ['date', 'type', 'description', 'amount', 'action'];
  totalData: any;
  filteredData: any;
  dataSource: any;
  defaultFilterType = "Last Year"
  appliedAdvanceFilters: AppliedFilters | null = null;

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private paymentService: GdoPaymentService,
    private dialog: MatDialog,
    private appService: AppService,
    private cdr: ChangeDetectorRef
  ) { }

  private markForCheck(): void {
    this.cdr.markForCheck();
  }

  ngOnInit(): void {

    this.filterForm = this.formBuilder.group({
      filter_prov: ["null"],
    });
    // this.dataSource.data = this.paymentService.getCompanies();
    this.getBillingHistory()
  }

  getMonthDifference(date: string | number | Date) {
    const currentDate = new Date()
    var previousDate = new Date(date);
    return (
      currentDate.getMonth() -
      previousDate.getMonth() +
      12 * (currentDate.getFullYear() - previousDate.getFullYear())
    );
  }

  trackByFilterType(index: number, type: { value: string }): string {
    return type.value;
  }

  trackByBillingRecord(index: number, record: AccountBilling): string | number {
    return record?.action || `${record?.date || ''}-${record?.type || ''}-${record?.amount || ''}-${index}`;
  }

  ngAfterViewInit() {
    this.callPagerAndSort();
  }

  callPagerAndSort() {
    if (this.filteredData) {
      // 
      this.filteredData = this.filteredData.sort((a: AccountBilling, b: AccountBilling) => {
        if (b.invoiceNo != null && a.invoiceNo != null && b.invoiceNo > a.invoiceNo) {
          return -1;
        } else return 1;
      });
      this.filteredData = this.filteredData.sort((a: AccountBilling, b: AccountBilling) => {
        if (a.filterType == "Invoice") {
          return -1;
        } else return 1;
      });
      // 
    }
    if (this.filteredData) {
      this.dataSource = new MatTableDataSource<any>(this.filteredData);
      if (this.dataSource) {
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    }
    this.markForCheck();
  }

  getBillingHistory() {
    let data = {};
    data = transformIntoApiCallObj(
      data,
      'get_acct_trans_history_m');
    this.appService.AriaPassThroughConnect(data).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((res) => {
      if (res && res.error_code === 0 && res.error_msg === "OK") {

        const rawData: TransHistory[] = res.history;
        const constructedData: AccountBilling[] = [];

        for (const iterator of rawData) {
          if (this.getMonthDifference(iterator.transaction_create_date ?? '') < 6) {
            this.defaultFilterType = "Last 6 Months"
            break;
          }
        }

        this.filterForm.get("filter_prov")?.setValue(this.defaultFilterType)

        const inVoiceData = rawData.filter(x => x.transaction_type === 21 || x.transaction_type === -21 || x.transaction_type === 22 || x.transaction_type === -22 || x.transaction_type === 1 || x.transaction_type === -1);
        const payment = rawData.filter(x => x.transaction_type != 21 && x.transaction_type != 22 && x.transaction_type != -22 && x.transaction_type != -21 && x.transaction_type != 1 && x.transaction_type != -1 && x.transaction_type != 8);
        // let refund = rawData.filter(x => x.transaction_type === 8);
        var holder = {} as any;
        const constructInvoiceData: AccountBilling[] = [];
        // refund.forEach(function (d) {
        //   if (holder.hasOwnProperty(d.statement_no)) {
        //     holder[d.statement_no!] =
        //       holder[d.statement_no!] + d.transaction_amount;
        //   } else {
        //     holder[d.statement_no!] = d.transaction_amount!;
        //   }
        // });
        // for (var prop in holder) {
        //   const res = refund.filter(x => x.statement_no === Number(prop));
        //   const type = Transaction_Types.filter(x => x.value === res[0].transaction_type);
        //   constructInvoiceData.push({
        //     amount: holder[prop],
        //     date: res[0].transaction_create_date,
        //     desc: "Credit",
        //     type: type[0].displayValue,
        //     filterType: "Refund",
        //   });
        // }

        // constructedData.push(...constructInvoiceData);

        for (const iterator of payment) {
          let obj: AccountBilling = {} as AccountBilling;
          obj.date = iterator.transaction_create_date ?? '';
          obj.amount = iterator.transaction_amount + "";
          obj.desc = iterator.transaction_desc ?? '';


          if (iterator.transaction_type === 2 || iterator.transaction_type === 3) {
            obj.filterType = 'Payment';
          } else if (iterator.transaction_type === 13 || iterator.transaction_type === -13 || iterator.transaction_type === 20 || iterator.transaction_type === -20) {
            obj.filterType = 'Refund';
          } else if (iterator.transaction_type === 10 || iterator.transaction_type === -10 || iterator.transaction_type === 11 || iterator.transaction_type === -11 || iterator.transaction_type === 24 || iterator.transaction_type === -24) {
            obj.filterType = 'Credit';
          } else {
            const filterType = Transaction_Types.filter(x => x.value === iterator.transaction_type);
            obj.filterType = filterType[0].displayValue;
          }

          const type = Transaction_Types.filter(x => x.value === iterator.transaction_type);
          obj.type = type[0].displayValue;

          obj.action = iterator.statement_no + "";
          // 
          obj.invoiceNo = iterator.invoice_no ?? undefined;

          constructedData.push(obj);
        }


        this.totalData = constructedData;

        this.dateFilterClick()

        this.callPagerAndSort();
        this.fetchInvoiceData(inVoiceData);
      }
    });
  }

  fetchInvoiceData(inVoiceData: TransHistory[]) {
    //  Updating the display logic so that only invoices that equal zero due to invoice line items(i.e type 21) all being zero are removed from the display.
    var holder = {} as any;
    inVoiceData.forEach((d: TransHistory) => {
      if (holder.hasOwnProperty(d.invoice_no)) {
        let showRecord = true;

        if (d.transaction_type === 21 && d.transaction_amount === 0 && !holder[d.invoice_no!].displayRecord) {
          showRecord = false;
        }

        holder[d.invoice_no!] = {
          amount: holder[d.invoice_no!].amount + d.transaction_amount,
          displayRecord: showRecord,
        };
      } else {
        holder[d.invoice_no!] = {
          amount: d.transaction_amount!,
          displayRecord: d.displayRecord ? d.displayRecord : false,
        };
      }
    });
    const constructInvoiceData: AccountBilling[] = [];

    const promiseArray: Promise<any>[] = [];

    for (var prop in holder) {
      const res = inVoiceData.filter(x => x.invoice_no === Number(prop));

      const type = Transaction_Types.filter(x => x.value === res[0].transaction_type);


      // Elimenate 0 amount records considering them as trial invoices 
      // if(holder[prop] !== 0){
      if (holder[prop].displayRecord) {
        constructInvoiceData.push({
          amount: holder[prop].amount.toFixed(2), date: res[0].transaction_create_date ?? '',
          desc: "",
          // type: type[0].displayValue,
          type: "Invoice",
          paymentMethod: "Invoice charge line",
          filterType: "Invoice",
          action: String(res[0].statement_no ?? ''),
          invoiceNo: Number(prop)
        });

        let inoviceData = {
          invoice_no: prop,
        };

        inoviceData = transformIntoApiCallObj(
          inoviceData,
          'get_invoice_details_m');

        promiseArray.push(this.appService.AriaPassThroughConnect(inoviceData).toPromise())
      }

    }

    const allPromise = Promise.all(promiseArray);

    allPromise.then(values => {
      this.filterInvoiceData(values, constructInvoiceData)
    }).catch(error => {

    });
  }

  filterInvoiceData(invoiceList: any[], constructInvoiceData: AccountBilling[]) {

    for (let [index, invoiceDetails] of invoiceList.entries()) {
      let invoiceDesc = ''
      const uniquePlanNameHolder: string[] = [];
      if (invoiceDetails && invoiceDetails.error_code === 0 && invoiceDetails.error_msg === "OK") {
        const rawInvoiceData: any[] = invoiceDetails.invoice_line_details;
        for (let invoiceIterator of rawInvoiceData) {
          if (invoiceIterator.plan_name) {
            if (!uniquePlanNameHolder.includes(invoiceIterator.plan_name)) {
              invoiceDesc = invoiceDesc + invoiceIterator.plan_name + ", "
              uniquePlanNameHolder.push(invoiceIterator.plan_name)
            }
          }
        }
      }
      if (constructInvoiceData && constructInvoiceData.length > 0 && constructInvoiceData[index]) {
        invoiceDesc = invoiceDesc.replace(/,\s*$/, "");
        // constructInvoiceData[index].desc = invoiceDesc
        constructInvoiceData[index].desc = "#" + constructInvoiceData[index].invoiceNo + " " + invoiceDesc;
      }
    }
    this.totalData.push(...constructInvoiceData);
    this.dateFilterClick();
    this.callPagerAndSort();
    this.markForCheck();
  }

  getRecord() {
    window.open('http://www.africau.edu/images/default/sample.pdf', '_blank');
  }

  dateFilterClick() {
    let selectedValue = this.filterForm.get("filter_prov")?.value
    if (selectedValue == "Custom Range") {
      this.openAdvancedFilters()
    } else {
      this.applyAdvanceFilters(this.appliedAdvanceFilters)
    }
  }


  openAdvancedFilters() {
    let ref = this.dialog.open(GdoAdvancedFilterationOptionsComponent, {
      // height: '72vh',
      // width: '58vw',
      data: this.appliedAdvanceFilters
    });

    ref.afterClosed().pipe(take(1)).subscribe(selectedAdFilters => {


      if (selectedAdFilters) {
        this.appliedAdvanceFilters = selectedAdFilters;
        this.applyAdvanceFilters(selectedAdFilters);
        this.markForCheck();
      }

    });
  }


  applyAdvanceFilters(filters: AppliedFilters | null) {
    // 
    if (filters && (filters.startDate || filters.endDate || filters.invoice || filters.payment || filters.credit || filters.refund)) {
      this.filteredData = this.totalData.filter((x: AccountBilling) => {
        if (filters.startDate && new Date(x.date!).setHours(0, 0, 0, 0) >= new Date(filters.startDate).setHours(0, 0, 0, 0) &&
          filters.endDate && new Date(x.date!).setHours(0, 0, 0, 0) <= new Date(filters.endDate).setHours(0, 0, 0, 0) &&
          filters.invoice && x?.filterType?.toLowerCase() === "invoice" &&
          filters.payment && x?.filterType?.toLowerCase() === "payment" &&
          filters.credit && x?.filterType?.toLowerCase() === "credit" &&
          filters.refund && x?.filterType?.toLowerCase() === "refund") {
          return true;
        }

        if (filters.startDate && new Date(x.date!).setHours(0, 0, 0, 0) >= new Date(filters.startDate).setHours(0, 0, 0, 0) &&
          filters.endDate && new Date(x.date!).setHours(0, 0, 0, 0) <= new Date(filters.endDate).setHours(0, 0, 0, 0) &&
          filters.payment && x?.filterType?.toLowerCase() === "payment") {
          return true;
        }

        if (filters.startDate && new Date(x.date!).setHours(0, 0, 0, 0) >= new Date(filters.startDate).setHours(0, 0, 0, 0) &&
          filters.endDate && new Date(x.date!).setHours(0, 0, 0, 0) <= new Date(filters.endDate).setHours(0, 0, 0, 0) &&
          filters.invoice && x?.filterType?.toLowerCase() === "invoice") {
          return true;
        }

        if (filters.startDate && new Date(x.date!).setHours(0, 0, 0, 0) >= new Date(filters.startDate).setHours(0, 0, 0, 0) &&
          filters.endDate && new Date(x.date!).setHours(0, 0, 0, 0) <= new Date(filters.endDate).setHours(0, 0, 0, 0) &&
          filters.credit && x?.filterType?.toLowerCase() === "credit") {
          return true;
        }

        if (filters.startDate && new Date(x.date!).setHours(0, 0, 0, 0) >= new Date(filters.startDate).setHours(0, 0, 0, 0) &&
          filters.endDate && new Date(x.date!).setHours(0, 0, 0, 0) <= new Date(filters.endDate).setHours(0, 0, 0, 0) &&
          filters.refund && x?.filterType?.toLowerCase() === "refund") {
          return true;
        }

        if (filters.startDate && new Date(x.date!).setHours(0, 0, 0, 0) >= new Date(filters.startDate).setHours(0, 0, 0, 0) &&
          filters.endDate && new Date(x.date!).setHours(0, 0, 0, 0) <= new Date(filters.endDate).setHours(0, 0, 0, 0) &&
          !filters.invoice && !filters.payment && !filters.credit && !filters.refund) {
          return true;
        }

        if (!filters.startDate && !filters.endDate && filters.payment && x?.filterType?.toLowerCase() === "payment") {
          return true;
        }
        if (!filters.startDate && !filters.endDate && filters.invoice && x?.filterType?.toLowerCase() === "invoice") {
          return true;
        }

        if (!filters.startDate && !filters.endDate && filters.credit && x?.filterType?.toLowerCase() === "credit") {
          return true;
        }

        if (!filters.startDate && !filters.endDate && filters.refund && x?.filterType?.toLowerCase() === "refund") {
          return true;
        }

        return false;
      });
      this.callPagerAndSort();

    } else {
      let selectedValue = this.filterForm.get("filter_prov")?.value
      if (selectedValue == "Custom Range") {
        this.filteredData = this.totalData
        this.callPagerAndSort();
      } else if (selectedValue == "Last 6 Months") {
        this.filteredData = this.totalData.filter((x: AccountBilling) => {
          if (this.getMonthDifference(x.date) < 6) {
            return true
          }
          return false
        });
        this.callPagerAndSort();
      } else if (selectedValue == "Last Year") {
        this.filteredData = this.totalData.filter((x: AccountBilling) => {
          let current = new Date(x.date!);
          let previous = new Date(x.date!);
          previous.setFullYear(previous.getFullYear() - 1);
          return current.getTime() > previous.getTime();
        });
        this.callPagerAndSort();
      }
    }
  }

  onApply() {
    let dialogRef = this.dialog.open(GdoAdvancedFilterationOptionsComponent, {
      data: {},
    });

    dialogRef.componentInstance.onFilterApply.pipe(take(1)).subscribe(() => {
      // do something
    });
    dialogRef.afterClosed().pipe(take(1)).subscribe(() => { });
  }

  async viewInvoice(element: any, download: boolean) {
    let reqObj = {
      invoice_no: element.invoiceNo,
    };

    reqObj = transformIntoApiCallObj(
      reqObj,
      'get_statement_for_invoice_m');
    const res = await this.appService.AriaPassThroughConnect(reqObj).toPromise();

    if (res.error_code === 0 && res.error_msg === "OK" && res.out_statement && res.out_statement.length > 0) {
      const htmlReport = res.out_statement;
      const passObj = {
        htmlReport: htmlReport,
        download: download,
        invoice_no: element.invoiceNo,
        statement_no: element.action // action is statment_no
      }
      let ref = this.dialog.open(GdoViewInvoiceComponent, {
        autoFocus: false,
        height: '72vh',
        width: '58vw',
        data: passObj
      });
    }
  }
  ResetFilters() {
    this.appliedAdvanceFilters = null;
    this.applyAdvanceFilters(this.appliedAdvanceFilters);
  }
}

export interface TransHistory {
  transaction_type?: number;
  transaction_desc?: string;
  transaction_amount?: number;
  transaction_currency?: string;
  transaction_create_date?: string;
  invoice_no?: number;
  transaction_id?: number;
  statement_no?: number;
  transaction_applied_amount?: number;
  transaction_source_id?: number;
  transaction_ref_code?: string;
  seq_statement_id?: string;
  displayRecord?: boolean;
}